<template>
  <div>
    <q-form
      ref="listStructureDetail"
      :model="structure"
      :rules="listStructureRules"
      label-width="120px"
    >
      <q-form-generator
        v-model="structure"
        :form-structure="formStructure"
      />
    </q-form>
    <span slot="footer">
      <q-button
        type="primary"
        @click="updateStructure"
      >
        {{ this.$qt('listStructure.confirmSetting') }}
      </q-button>
      <q-button
        @click="close()"
      >
        {{ this.$qt('listStructure.rejectSetting') }}
      </q-button>
    </span>
  </div>
</template>

<script>
  import caller from '../../../q-components/q-caller'

  export default {
    name: "ListStructureDetail",

    props: {
      value: {required: true}
    },

    data() {
      return {
        structure: undefined,
        listStructureRules: {},
        formStructure: {}
      }
    },

    watch: {
      structure() {
        this.$emit('input', this.structure);
      },
      value() {
        this.structure = this.value;
      }
    },

    created() {
      this.structure = this.value;
    },

    mounted() {
      this.$delegate('structure', 'fetchFormStructure', {
        structureKey: 'listStructureDetail'
      }).then((response) => {
        this.formStructure = response.result;
      }).catch(() => {
      });
    },


    methods: {
      close() {
        this.$emit('close')
      },
      updateStructure() {
        this.$delegate(this.formStructure.plugin, 'updateFormStructure', {
          model: this.structure
        }).then((response) => {
          this.$notify({
            title:  this.$qt('listStructure.methodSuccessTitle'),
            message:  response.message ,
            type: 'success'
          });
        }).catch(() => {
        });
      }
    }
  }
</script>

<style scoped>

</style>